import { render, staticRenderFns } from "./b-performance-export-dropdown.vue?vue&type=template&id=dada5b88&scoped=true"
import script from "./b-performance-export-dropdown.vue?vue&type=script&lang=js"
export * from "./b-performance-export-dropdown.vue?vue&type=script&lang=js"
import style0 from "./b-performance-export-dropdown.vue?vue&type=style&index=0&id=dada5b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dada5b88",
  null
  
)

export default component.exports